import { useMemo } from 'react';

import { ALL_APP_CONFIGS } from '@hcs/app-configs';
import { PlatformIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

import { useCurrentUrlRootPath } from './useCurrentUrlRootPath';

// Fallback AppConfig that allows user access to the app
const APP_CONFIG_FALLBACK: AppConfig = {
  appSlugForEngagement: AppSlugs.Platform,
  type: 'external-app',
  Icon: PlatformIcon,
  applicationKey: 'platform',
  rootPath: '/',
  name: '',
  descriptionLong: '',
  descriptionShort: '',
};

// assumption that we won't have the same rootPath between internal and external apps
export const useCurrentAppConfig = (): AppConfig => {
  const currentRootPath = useCurrentUrlRootPath();
  return (
    useMemo(
      () => ALL_APP_CONFIGS.find((c) => c.rootPath === currentRootPath),
      [currentRootPath],
    ) || APP_CONFIG_FALLBACK
  );
};
